export default "__VITE_ASSET__CHhPgDJy__"